<!-- Bottom tab bar — visible uniquement sur mobile (<900px) -->
<nav class="bottom-tabs" role="navigation" [attr.aria-label]="'tabbar.aria_main' | transloco">
  <button
    *ngFor="let tab of tabs"
    type="button"
    class="tab"
    [class.active]="isActive(tab)"
    (click)="go(tab)"
    [attr.aria-current]="isActive(tab) ? 'page' : null"
  >
    <span class="material-icons-outlined icon">{{ tab.icon }}</span>
    <span class="label">{{ tab.label | transloco }}</span>
    <span class="badge" *ngIf="badgeFor(tab) > 0">{{ badgeFor(tab) > 99 ? '99+' : badgeFor(tab) }}</span>
  </button>
</nav>

<!-- Bottom Sheet "Plus" -->
<div
  class="more-backdrop"
  *ngIf="moreOpen()"
  (click)="closeMore()"
  aria-hidden="true"
></div>

<aside
  class="more-sheet"
  *ngIf="moreOpen()"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'tabbar.more_options' | transloco"
>
  <div class="more-handle" aria-hidden="true"></div>

  <header class="more-head">
    <h3>{{ 'tabbar.more_options' | transloco }}</h3>
    <button type="button" class="more-close" (click)="closeMore()" [attr.aria-label]="'common.close' | transloco">
      <span class="material-icons-outlined">close</span>
    </button>
  </header>

  <div class="more-grid">
    <button
      *ngFor="let item of moreItems"
      type="button"
      class="more-card"
      [attr.data-tone]="item.tone"
      (click)="goMore(item)"
    >
      <span class="more-icon">
        <span class="material-icons-outlined">{{ item.icon }}</span>
      </span>
      <span class="more-text">
        <strong>{{ item.label | transloco }}</strong>
        <small>{{ item.sub | transloco }}</small>
      </span>
    </button>
  </div>
</aside>
